<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="less">
@import "./assets/lib/initStyle.less";
@import "./assets/lib/font-awesome-4.7.0/less/font-awesome.less";
@import "./assets/lib/animate/animate.less";
</style>



// WEBPACK FOOTER //
// src/App.vue